import { repositoryHost } from "@/repositories";
import { serviceHost } from "@/services";
import { useQuery } from "@tanstack/react-query";

const databaseService = serviceHost.getDatabaseService();
const userRepository = repositoryHost.getUserRepository(databaseService);

export const useUser = (id: string) => {
  return useQuery({
    queryKey: ["user", "id", id],
    queryFn: () => userRepository.get({ id }),
    enabled: !!id,
  });
};
